<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <mat-stepper
      #linearVerticalStepper="matVerticalStepper"
      formArrayName="scpis"
      [linear]="true"
      (selectionChange)="stepClick($event)"
    >
      @for (scpi of scpis.controls; track scpi; let i = $index) {
        @if (productIds?.includes(scpi.get('productId')?.value)) {
          <mat-step
            [formGroup]="scpi"
            [stepControl]="scpis?.get([i])"
            completed="false"
          >
            <ng-container formGroupName="parameters">
              <ng-template matStepLabel>{{
                scpi?.get('productName')?.value
              }}</ng-template>
              <div class="row row-flex">
                <div class="col col-md-12">
                  <pr-input-radio
                    [derrors]="derrors"
                    formControlName="scpiReinvestDividend"
                    columns="3"
                    [toggle]="true"
                    [isDefault]="false"
                    label="Voulez vous réinvestir vos dividendes"
                  >
                  </pr-input-radio>
                </div>
                @if (
                  scpi?.get('parameters').get('scpiReinvestDividend')?.value
                ) {
                  <div class="col col-md-12">
                    <pr-input-column
                      label="Quel pourcentage souhaitez vous réinvestir ?"
                      [derrors]="derrors"
                    >
                      <input
                        formControlName="scpiReinvestDividendPercent"
                        type="number"
                        min="0"
                        max="100"
                        fraction="2"
                      />
                      <i>%</i>
                    </pr-input-column>
                  </div>
                }
              </div>
            </ng-container>
          </mat-step>
        }
      }
    </mat-stepper>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
